<div class="dialog-header-container">
  <h1 mat-dialog-title class="mar-b-5 pd-t-5px">Add Predefined Notes</h1>
  <div>
    <button mat-icon-button mat-dialog-close aria-label="Example icon-button with heart icon">
        <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class = "mat-divider"></mat-divider>
<form [formGroup]= "notesEditBox">
<div class="content-container">
  <div mat-dialog-content class="predifedNotes">
    <div class="text-container mar-t-5">
      <mat-form-field class="text-area-container">
        <mat-label>Predefined Notes</mat-label>
        <textarea formControlName = "defaultNotes" (input) = "trackPredefinedNotes($event)" matInput class="text-area-container body-font-size"></textarea>
      </mat-form-field>
      <button class="global-icn-bttn-container predefinedAdd" (click) = "addPredefinedNotes()" mat-mini-fab ><mat-icon>add</mat-icon></button>
    </div>
    <ng-container *ngIf = "predefinedNotesArray.length != 0">
      <div id = "list{{index}}" *ngFor = "let notes of predefinedNotesArray; let index = index" style=" overflow-x: hidden; overflow-y: hidden;display: flex;">
        <mat-form-field class="text-area-container">
          <mat-label>Predefined Notes</mat-label>
          <textarea formControlName = "defaultNotes" (input) = "trackPredefinedNotes($event)" matInput class="text-area-container body-font-size"></textarea>
        </mat-form-field>
        <button class="global-icn-bttn-container predefinedDelete" (click) = "deleteListItem(index)" mat-mini-fab ><mat-icon>delete</mat-icon></button>
        <!-- <ul>
          <li id = "list{{index}}" *ngFor = "let notes of predefinedNotesArray; let index = index">
            {{notes}}
            <button (click) = "deleteListItem(index)" mat-icon-button id = "list-delete{{index}}"><mat-icon>delete</mat-icon></button>
          </li>
        </ul> -->
      </div>
    </ng-container>
    
  </div>
  <div mat-dialog-actions class="button-actions-container">
    <button (click) = "updatePredefineNotes()" mat-button class="button-container primary">Save</button>
    <button mat-button class="button-container primary" mat-dialog-close>Cancel</button>
  </div>
</div>
</form>